import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

// Components
import {
  IconAccidentFilled,
  IconBAPlusFilled,
  IconBAPlusPlusFilled,
} from 'wg-fe-ui';
import OffersFilterBarItem from './OffersFilterBarItem';

// Types
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/redux/reducers/rootReducer';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveCarQuoteFilter } from '../../../store/redux/slices/offersSlice';
import { SimpleGrid } from '@wegroup/design-system';
import { isSocialLoginUrl } from '../../../../../app/src/features/authentication/constants/SocialAuth';

interface Props {
  guarantees?: string[];
}

const DesktopOffersFilterBar: React.FC<React.PropsWithChildren<Props>> = ({
  guarantees,
  ...otherProps
}) => {
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);

  const dispatch = useDispatch();
  const activeCarQuoteFilter = useSelector(
    (state: RootState) => state.offers.activeCarQuoteFilter,
  );

  // Dirty code, will be removed
  const getAmountOfFilters = () => {
    let total = 1;

    if (
      guarantees?.some((guarantee) => guarantee.toLowerCase() === 'mini_omnium')
    )
      total++;

    if (guarantees?.some((guarantee) => guarantee.toLowerCase() === 'omnium'))
      total++;

    return isSocialLoginUrl ? 3 : total;
  };

  return (
    <SimpleGrid
      gap={{ base: '2', laptop: '4' }}
      columns={getAmountOfFilters()}
      mb="4"
      {...otherProps}
    >
      <OffersFilterBarItem
        Icon={<IconAccidentFilled color={theme.primary[500]} />}
        title={t('CIVIL_LIABILITY')}
        active={activeCarQuoteFilter === 'civil_liability'}
        onClick={() => dispatch(setActiveCarQuoteFilter('civil_liability'))}
      />
      {(isSocialLoginUrl ||
        guarantees?.some(
          (guarantee) => guarantee.toLowerCase() === 'mini_omnium',
        )) && (
        <OffersFilterBarItem
          Icon={<IconBAPlusFilled color={theme.primary[500]} />}
          title={t('mini_omnium')}
          active={activeCarQuoteFilter === 'mini_omnium'}
          onClick={() => dispatch(setActiveCarQuoteFilter('mini_omnium'))}
        />
      )}

      {(isSocialLoginUrl ||
        guarantees?.some(
          (guarantee) => guarantee.toLowerCase() === 'omnium',
        )) && (
        <OffersFilterBarItem
          Icon={<IconBAPlusPlusFilled color={theme.primary[500]} />}
          title={t('omnium')}
          active={activeCarQuoteFilter === 'omnium'}
          onClick={() => dispatch(setActiveCarQuoteFilter('omnium'))}
        />
      )}
    </SimpleGrid>
  );
};

export default DesktopOffersFilterBar;
